export default __webpack_public_path__ + "static/media/inspire_web-xs@2x.ec5fe186.webp";